<template>
  <div :class="divClass">
    <p align="center" class="mb-2">
      <strong>
        {{ etiqueta }}
        <!--<span v-if="obligatorio" style="font-size: 1.2rem; margin: 0.1rem; color: red;">*</span>-->
      </strong>
    </p>
    <b-form-input
      ref="inputpond"
      :value="value"
      type="text"
      class="w-100 form-control form-control-lg rounded-0 py-1"
      :min="minVal"
      :max="maxVal"
      maxlength="4"
      placeholder="0"
      :state="validar"
      @input.native="handler"
    />
    <b-form-invalid-feedback>Valor Incorrecto</b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: "InputPuntaje",
  props: ["etiqueta", "obligatorio", "minVal", "maxVal", "value", "divClass"],
  data() {
    return {
      valor: 0
    };
  },
  computed: {
    validar() {
      if (
        (this.obligatorio && this.value !== "") ||
        (!this.obligatorio && this.value !== "" && this.value !== "0")
      ) {
        if (this.value !== "") {
          let valorInt = parseInt(this.value);
          if (valorInt >= this.minVal && valorInt <= this.maxVal) {
            return true;
          } else {
            return false;
          }
        } else {
          return null;
        }
      }
    }
  },
  methods: {
    handler(e) {
      this.valor = e.target.value;

      if (this.validador(e.target.value)) {
        e.target.value = e.target.value.replace(/.$/, "");
      }
      if (this.valor != e.target.valor) {
        this.$emit("input", e.target.value);
      }
    },
    validador(value) {
      if (!/^[0-9]+$/.test(value)) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/simuladorPonderaciones/InputPuntaje.vue